<!--
 * @Author: mzw
 * @Date: 2025-04-23 09:14:50
 * @LastEditTime: 2025-05-06 15:52:02
 * @LastEditors: mzw
 * @Description: 物料助手-详情/编辑
-->
<template>
  <div>
    <el-drawer
      :visible.sync="visible"
      title="通知详情"
      direction="rtl"
      :before-close="onCancel"
      size="90%"
      custom-class="drawer"
      :show-close="false"
    >
      <!-- 自定义头部 -->
      <template slot="title">
        <el-button
          type="primary"
          size="small"
          @click="onCancel"
        >返回
        </el-button>
        <div>
          <el-button
            type="primary"
            size="small"
            @click="toggleEdit(true)"
            v-if="!isEdit"
          >编辑
          </el-button>
          <div v-else>
            <el-button
              type="primary"
              size="small"
              @click="doSave"
              :loading="saveLoading"
            >保存
            </el-button>
            <el-button
              size="small"
              @click="exitEdit"
            >放弃
            </el-button>
          </div>
        </div>
      </template>

      <el-form
        :model="dataForm"
        :rules="dataRule"
        ref="dataForm"
        size="small"
        label-width="auto"
      >
        <h2 class="sub-title">基本信息</h2>
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item
              label="客户名称："
              prop="companyName"
            >
              <template>
                {{info.companyName || '-'}}
              </template>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="需求名称："
              prop="demandName"
            >
              <template v-if="!isEdit">
                {{info.demandName || '-'}}
              </template>
              <el-input
                v-else
                v-model="dataForm.demandName"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="任务编号：">
              {{info.taskNo || '-'}}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item label="用户名称：">
              {{info.createUserName || '-'}}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="联系方式："
              prop="contactInformation"
            >
              <template v-if="!isEdit">
                {{info.contactInformation || '-'}}
              </template>
              <el-input
                v-else
                v-model="dataForm.contactInformation"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="创建时间：">
              {{info.createTime || '-'}}
            </el-form-item>
          </el-col>
        </el-row>
        <el-link
          v-if="info.fileUrl"
          :href="info.fileUrl"
          type="primary"
          style="margin-bottom:12px"
        >原始文件</el-link>

        <h2 class="sub-title">详细信息</h2>
        <el-card class="card-box">
          <el-row type="flex">
            <el-col :span="8">
              <div class="card-info">
                <h3>原始信息</h3>
                <el-form-item label="物料编码：">
                  {{info.originalMaterialCode || '-'}}
                </el-form-item>
                <el-form-item label="物料描述：">
                  {{info.originalMaterialDesc || '-'}}
                </el-form-item>
                <el-form-item label="品牌名称：">
                  {{info.originalBrandName || '-'}}
                </el-form-item>
                <el-form-item label="规格：">
                  {{info.originalSpec || '-'}}
                </el-form-item>
                <el-form-item label="型号：">
                  {{info.originalModel || '-'}}
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="card-info">
                <h3>规范化描述</h3>
                <el-form-item
                  label="物料短名称："
                  prop="materialShortName"
                >
                  <template v-if="!isEdit">
                    {{info.materialShortName || '-'}}
                  </template>
                  <el-input
                    v-else
                    v-model="dataForm.materialShortName"
                    @change="updateAttributeInfoList"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="物料长名称："
                  prop="materialLongName"
                >
                  <template v-if="!isEdit">
                    {{info.materialLongName || '-'}}
                  </template>
                  <el-input
                    v-else
                    v-model="dataForm.materialLongName"
                    @change="updateAttributeInfoList"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="品牌名称："
                  prop="materialBrandName"
                >
                  <template v-if="!isEdit">
                    {{info.materialBrandName || '-'}}
                  </template>
                  <el-input
                    v-else
                    v-model="dataForm.materialBrandName"
                    @change="updateAttributeInfoList"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="规格："
                  prop="materialSpec"
                >
                  <template v-if="!isEdit">
                    {{info.materialSpec || '-'}}
                  </template>
                  <el-input
                    v-else
                    v-model="dataForm.materialSpec"
                    @change="updateAttributeInfoList"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="型号："
                  prop="materialModel"
                >
                  <template v-if="!isEdit">
                    {{info.materialModel || '-'}}
                  </template>
                  <el-input
                    v-else
                    v-model="dataForm.materialModel"
                    @change="updateAttributeInfoList"
                  ></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="card-info recommend">
                <div class="img-box">
                  <!-- 就一张图？？ -->
                  <template v-if="!isEdit">
                    <el-image
                      v-if="info.goodsPictureUrl"
                      :zoom-rate="1.2"
                      :max-scale="7"
                      :min-scale="0.2"
                      :src="info.goodsPictureUrl"
                      :preview-src-list="[info.goodsPictureUrl]"
                      fit="contain"
                      :z-index="9999"
                      :initial-index="0"
                      :preview-teleported="true" />
                  </template>
                  <template v-else>
                    <el-image
                      v-if="dataForm.goodsPictureUrl"
                      :zoom-rate="1.2"
                      :max-scale="7"
                      :min-scale="0.2"
                      :src="dataForm.goodsPictureUrl"
                      :preview-src-list="[dataForm.goodsPictureUrl]"
                      fit="contain"
                      :z-index="9999"
                      :initial-index="0"
                      :preview-teleported="true" />
                  </template>
                </div>
                <h3>推荐商品</h3>
                <el-form-item label="商品编码：">
                  {{ !isEdit ? info.goodsCode||'-': dataForm.goodsCode||'-'}}
                  <span
                    v-if="isEdit"
                    class="edit-btn"
                    @click="toggleGoodsV(true)"
                  >
                    <i class="el-icon-edit-outline"></i>
                  </span>
                </el-form-item>
                <el-form-item label="商品名称：">
                  {{!isEdit ? info.goodsName||'-' : dataForm.goodsName||'-'}}
                </el-form-item>
                <el-form-item label="商品品牌：">
                  {{!isEdit ? info.goodsBrand||'-': dataForm.goodsBrand||'-'}}
                </el-form-item>
                <el-form-item label="规格：">
                  {{!isEdit ? info.goodsSpec||'-': dataForm.goodsSpec||'-'}}
                </el-form-item>
                <el-form-item label="型号：">
                  {{!isEdit ? info.goodsModel||'-': dataForm.goodsModel||'-'}}
                </el-form-item>
                <el-form-item label="推荐分值：">
                  {{!isEdit ? info.matchScore||'-': dataForm.matchScore||'-'}}
                </el-form-item>
              </div>
            </el-col>
          </el-row>
        </el-card>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="分类：" prop="thirdCategoryId">
              <template v-if="!isEdit">
                <template v-if="info.firstCategoryName || info.secondCategoryName || info.thirdCategoryName">
                  {{info.firstCategoryName || '-'}} > {{info.secondCategoryName || '-'}} > {{info.thirdCategoryName || '-'}}
                </template>
                <template v-else>-</template>
              </template>
              <!-- 传最后一级的id↓ -->
              <el-cascader
                v-else
                ref="categoryCascader"
                :options="classificationTree"
                v-model="dataForm.thirdCategoryId"
                @change="handleCategoryChange"
                :props="{
                  emitPath: false,
                  label: 'name',
                  value: 'backgroundCategoryId',
                }"
                clearable
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="物料标签："
              prop="tagCodeList"
            >
              <span class="material-tags" v-if="!isEdit">
                <!-- tagCodeList -->
                <template v-if="info.tagCodeList && info.tagCodeList.length>0">
                  <el-tag
                    effect="plain"
                    v-for="(mt,mi) in info.tagCodeList"
                    :key="mi"
                    :type="mt=='4' ? 'success' : 'danger' "
                  >
                    <!-- 标准商品(code='4')为绿色，其他都为红色 -->
                    {{
                      $getDictLabel('AI_MATERIAL_ASSISTANT_TAG', mt) ||
                      '-'
                    }}
                  </el-tag>
                </template>
                <template v-else>-</template>
              </span>
              <el-select
                v-else
                filterable
                multiple
                clearable
                collapse-tags
                v-model="dataForm.tagCodeList"
              >
                <el-option
                  v-for="(tm,ti) in tagList"
                  :key="ti"
                  :label="tm.value"
                  :value="tm.code"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <h2 class="sub-title">参数诊断结果</h2>
      <p>
        参数缺失率：{{!isEdit ? info.missingRate : dataForm.missingRate | formatePercent }}
        <br/>
        缺失属性：{{!isEdit ? info.missingAttributes||'-' : dataForm.missingAttributes||'-'}}
      </p>
      <Table
        ref="table"
        :tableConfig="tableConfig"
      >
      </Table>

      <h2 class="sub-title">
        采购参考建议
        <el-button
          v-if="!info.purchaseAdvice"
          @click="getPurchaseAdvice"
          type="primary"
          size="small"
        >查看建议</el-button>
      </h2>
      <p v-loading="purchaseAdviceLoading && !info.purchaseAdvice">
        {{info.purchaseAdvice}}
      </p>

    </el-drawer>

    <!-- 推荐商品 -->
    <MaterialGoods
      v-if="goodsVisible"
      :visible="goodsVisible"
      :taskDetailId="taskDetailId"
      :extraData="dataForm"
      @toggleVisible="toggleGoodsV"
      @checked="checkedGood"
    >
    </MaterialGoods>
  </div>
</template>

<script>
import Table from '@/components/table/index';
import MaterialGoods from "./MaterialGoods.vue";
import { mul } from '@/utils/numberComputed';

export default {
  name: 'MaterialEdit',
  components: {
    Table,
    MaterialGoods
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    taskDetailId: {
      type: String
    },
    classificationTree: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      tagList: [
        ...(window.SITE_CONFIG.dictList.AI_MATERIAL_ASSISTANT_TAG || '')
      ], // 标签
      isEdit: false,
      saveLoading: false, //正在保存
      purchaseAdviceLoading: false, //正在生成采购参考建议

      info: {},
      dataForm: {
        
      },
      dataRule: {
        demandName: [
          { required: true, message: '必填项不能为空', trigger: 'change' }
        ]
      },

      goodsVisible: false, //推荐商品弹窗

      tableConfig: {
        extra: {},
        autoSearch: false,
        needPagination: false,
        maxHeight: "400px",
        params: [
          {
            prop: "attributeName",
            label: "属性名称",
            minWidth: "150",
            showOverflowTooltip: true
          },
          {
            prop: "exactMatch",
            label: "命中参数值",
            minWidth: "150",
            showOverflowTooltip: true
          },
          {
            prop: "possibleMatch",
            label: "近似参数值",
            minWidth: "150",
            showOverflowTooltip: true
          }
        ]
      }
    }
  },
  filters: {
    formatePercent(val) {
      if (val) {
        // 转换为%
        return mul(val, 100).toFixed(2) + '%'
      }
      return val === null||val ===undefined ? '-' : '0.00%'
    }
  },
  mounted () {
    this.$nextTick(()=>{
      this.getDetailInfo()
    })
  },
  methods: {
    getDetailInfo() {
      this.$http
        .get(`/help/ai/user/materialAssistant/detail/info?taskDetailId=${this.taskDetailId}`)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return false
          }
          // 原始的数据
          this.info = {...res.data}
          // 修改的数据
          this.dataForm = {...res.data}

          this.updateAttributeTable()
        })
    },
    getPurchaseAdvice() {
      this.purchaseAdviceLoading = true
      this.$http
        .post(`/help/ai/user/materialAssistant/detail/purchaseAdvice?taskDetailId=${this.taskDetailId}`)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return false
          }
          this.info.purchaseAdvice = res.data.purchaseAdvice
        })
        .finally(() => {
          this.purchaseAdviceLoading = false;
        });
    },
    toggleEdit(flag) {
      this.isEdit = flag
    },
    // 放弃编辑
    exitEdit() {
      this.toggleEdit(false)
      this.$refs.dataForm.clearValidate() //只清除表单校验
    },
    // 选择推荐商品
    toggleGoodsV(flag) {
      this.goodsVisible = flag
    },
    checkedGood(row) {
      this.dataForm.goodsCode = row.skuCode
      this.dataForm.goodsName = row.skuName
      this.dataForm.goodsBrand = row.brandName
      this.dataForm.goodsSpec = row.specification
      this.dataForm.goodsModel = row.model
      this.dataForm.matchScore = row.matchScore
      this.dataForm.goodsPictureUrl = row.fileUrl
      this.toggleGoodsV(false)
      this.updateAttributeInfoList()
    },
    // 选择三级类目
    handleCategoryChange (value) {
      // 保存接口入参需要：最后一级的id，及所有级的name
      this.dataForm.thirdCategoryId = value
      const nodePathLabels = this.$refs.categoryCascader.getCheckedNodes()[0].pathLabels
      this.dataForm.firstCategoryName = nodePathLabels[0] || ''
      this.dataForm.secondCategoryName = nodePathLabels[1] || ''
      this.dataForm.thirdCategoryName = nodePathLabels[2] || ''

      this.updateAttributeInfoList()
    },
    // 更新属性列表
    updateAttributeInfoList() {
      const params = {
        goodsCode: this.dataForm.goodsCode,
        matchScore: this.dataForm.matchScore,
        materialBrandName: this.dataForm.materialBrandName,
        materialModel: this.dataForm.materialModel,
        materialShortName: this.dataForm.materialShortName,
        thirdCategoryId: this.dataForm.thirdCategoryId,
        taskDetailId: this.taskDetailId
      }
      this.$http
        .post('/help/ai/user/materialAssistant/detail/getAttributeInfoList', params)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return false
          }
          this.dataForm.matchedAttributeList = res.data.matchedAttributeList || []
          this.dataForm.missingRate = res.data.missingRate
          this.dataForm.missingAttributes = res.data.missingAttributes

          this.updateAttributeTable()
        })
    },
    // 更新属性table数据
    updateAttributeTable() {
      this.$refs.table.dataList = !this.isEdit ? this.info.matchedAttributeList||[] : this.dataForm.matchedAttributeList||[]
    },
    // 编辑保存
    doSave() {
      this.$refs.dataForm.validate((valid) => {
        if (!valid) {
          return
        }
        this.saveLoading = true
        const params = {
          companyId: this.dataForm.companyId,
          companyName: this.dataForm.companyName,
          contactInformation: this.dataForm.contactInformation,
          demandName: this.dataForm.demandName,
          goodsBrand: this.dataForm.goodsBrand,
          goodsCode: this.dataForm.goodsCode,
          goodsModel: this.dataForm.goodsModel,
          goodsName: this.dataForm.goodsName,
          goodsSpec: this.dataForm.goodsSpec,
          goodsPictureUrl: this.dataForm.goodsPictureUrl,
          matchScore: this.dataForm.matchScore,
          materialShortName: this.dataForm.materialShortName,
          materialLongName: this.dataForm.materialLongName,
          materialBrandName: this.dataForm.materialBrandName,
          materialSpec: this.dataForm.materialSpec,
          materialModel: this.dataForm.materialModel,
          tagCodeList: this.dataForm.tagCodeList,
          taskDetailId: this.taskDetailId,
          thirdCategoryId: this.dataForm.thirdCategoryId,
          firstCategoryName: this.dataForm.firstCategoryName,
          secondCategoryName: this.dataForm.secondCategoryName,
          thirdCategoryName: this.dataForm.thirdCategoryName,
          matchedAttributeList: this.dataForm.matchedAttributeList,
          missingRate: this.dataForm.missingRate,
          missingAttributes: this.dataForm.missingAttributes
        }
        this.$http
          .post('/help/ai/user/materialAssistant/detail/updateInfo', params)
          .then(({ data: res }) => {
            if (res.code !== 0) {
              return false
            }
            this.$message.success("保存成功");
            this.$emit("editSuccess");
          })
          .finally(() => {
            this.saveLoading = false;
          });
      })
    },
    onCancel() {
      this.$emit("toggleVisible", false);
    }
  },
}
</script>

<style lang="scss" scoped>
.container {
  height: 100%;
}
::v-deep .el-drawer__header {
  margin-bottom: 0 !important;
  justify-content: space-between;
  & > :first-child {
    flex: 0
  }
}
::v-deep .el-drawer__body {
  padding: 20px !important;
}

h2.sub-title {
  font-size: 1.1em;
  border-left: 3px solid var(--color-primary);
  padding-left: 5px;
}

.light-line{
  color: var(--color-primary);
  word-break: break-all;
  &:hover {
    text-decoration: underline;
  }
}

.card-box{
  width: 100%;
  word-break: break-all;
  margin-bottom: 12px;
  ::v-deep img {
    max-width: 100%;
  }
  ::v-deep .el-card__body{
    padding: 0;
  }
  .card-info {
    padding: 15px;
    border-right: 1px solid #eee;
    height: 100%;
    &.recommend {
      border-right: none;
      position: relative;
      .img-box {
        position: absolute;
        top: 15px;
        right: 15px;
        width: 100px;
        height: 100px;
        cursor: pointer;
      }
    }
  }
}

.edit-btn {
  margin-left: 5px;
}

.material-tags{
  ::v-deep .el-tag {
    margin-right: 4px;
  }
}

::v-deep .el-form-item {
  margin-bottom: 15px;
  .el-form-item__content {
    word-break: break-all;
  }
}

::v-deep .search-table {
  padding: 12px 0 !important;
}
</style>